export default __webpack_public_path__ + "static/media/t_audio.60f9d908.png";